<template>
    <button @click="toggleMenu"
            class="z-20 w-14 h-14 rounded-full bg-blue-700 fixed left-4 bottom-8 lg:hidden flex items-center justify-center">
        <Hamburger v-if="!menuOpen"/>
        <Cross v-else/>
    </button>
</template>

<script>
import Hamburger from "@/Components/Icons/Hamburger"
import Cross from "@/Components/Icons/Cross"

export default {
    props: ['menuOpen'],
    components: {
        Hamburger,
        Cross,
    },
    methods: {
        toggleMenu() {
            this.$emit('toggleMenu');
        }
    }
}
</script>
